














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Browse extends Vue {
    @Prop()
    private libraryId !: number;
    @Prop()
    private chapterId !: number;

    private loading = false;

    private pagedData = [];

    created() {
        this.reload();
    }

    reload() {
        
        this.$apis.getTopics(this.libraryId, this.chapterId)
            .then((res: any) => {
                this.pagedData = res.data;
            });
    }
}
